import { getAffiliateCookieData } from './affiliateCookie';

const STENA_LINE_AFFILIATE_IDS = [
  '850001',
  '850002',
  '850003',
  '850004',
  '850005',
  '850006',
  '850007',
  '850008',
  '850009',
  '850010',
  '850011',
  '850012',
  '850013',
  '850014',
  '850015',
  '850016',
  '850017',
];

export function isStenaLineAffiliateInUrlOrCookie(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const affiliateId =
    urlParams.get('affiliate-id') ??
    getAffiliateCookieData()?.affiliateCookieParams.AffiliateId;
  return affiliateId ? STENA_LINE_AFFILIATE_IDS.includes(affiliateId) : false;
}

export function isStenaLineAffiliateInURL(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const affiliateId = urlParams.get('affiliate-id');
  return affiliateId ? STENA_LINE_AFFILIATE_IDS.includes(affiliateId) : false;
}
